export default "__VITE_ASSET__DQI$QQtD__"